require('./RAErrorScreen.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const RAOKCover = require('../RAOKCover/RAOKCover');
const { OKBreadcrumb } = require('commonsComponents/OKBreadcrumb');
const { FormattedText } = require('core/i18n').i18n;

class RAErrorScreen extends React.Component {
    constructor(props) {
        super(props);
        this.handleMainButtonClick = this.handleMainButtonClick.bind(this);
        this.handleRedirectToSecondaryButtonURL = this.handleRedirectToSecondaryButtonURL.bind(
            this,
        );
    }

    handleMainButtonClick() {
        const {
            history,
            onMainButtonClick,
            mainButton: { url },
        } = this.props;

        return onMainButtonClick
            ? onMainButtonClick()
            : url
            ? history.push(url)
            : history.goBack();
    }

    handleRedirectToSecondaryButtonURL() {
        const {
            history,
            secondaryButton: { url },
        } = this.props;

        if (url) {
            history.push(url);
        } else {
            history.goBack();
        }
    }

    render() {
        const {
            children,
            heading,
            mainButton,
            mappingBreadcrumb,
            secondaryButton,
        } = this.props;

        let myMainButton;
        let mySecondaryButton;
        let myButtons;

        if (mainButton.label) {
            myMainButton = (
                <div className="ra-error-screen__main-button">
                    <OKButton
                        id="ra-error-screen_mainButton"
                        modifier="secondary"
                        onClick={this.handleMainButtonClick}
                    >
                        {mainButton.label}
                    </OKButton>
                </div>
            );
        }

        if (secondaryButton.label) {
            mySecondaryButton = (
                <div className="ra-error-screen__secondary-button">
                    <OKButton
                        id="ra-error-screen_secondaryButton"
                        modifier="ghost"
                        onClick={this.handleRedirectToSecondaryButtonURL}
                    >
                        {secondaryButton.label}
                    </OKButton>
                </div>
            );
        }

        if (myMainButton || mySecondaryButton) {
            myButtons = (
                <div className="ra-error-screen__footer">
                    <div className="ra-error-screen__separator" />
                    <div className="ra-error-screen__foot-buttons">
                        {myMainButton} {mySecondaryButton}
                    </div>
                </div>
            );
        }

        return (
            <React.Fragment>
                <div className="container-fluid">
                    <div className="row">
                        <RAOKCover
                            size="medium"
                            section="investment"
                            customClass="col-xs-12"
                        >
                            <div className="ra-error-screen__header">
                                <div className="ra-error-screen__header-breadcrumb">
                                    <OKBreadcrumb mapping={mappingBreadcrumb} />
                                </div>
                                <div className="ra-error-screen__error-icon">
                                    <i className="ra-error-screen__error-icon-content ra-error-screen__error-icon"></i>
                                </div>
                                <div className="ra-error-screen__header-extra-content">
                                    <FormattedText value={heading} />
                                </div>
                            </div>
                        </RAOKCover>
                    </div>
                </div>
                <div className="row ra-error-screen__container">
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="ra-error-screen__container-description">
                                {children}
                            </div>
                            {myButtons}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

RAErrorScreen.defaultProps = {
    mainButton: {},
    secondaryButton: {},
    customClassName: '',
};

RAErrorScreen.propTypes = {
    errorMessage: PropTypes.string,
    heading: PropTypes.string,
    customClassName: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    mappingBreadcrumb: PropTypes.array,
    mainButton: PropTypes.object,
    history: PropTypes.object.isRequired,
    secondaryButton: PropTypes.object,
    onMainButtonClick: PropTypes.func,
};

module.exports = withRouter(RAErrorScreen);
